module.exports = __webpack_public_path__ + "static/media/zip-editor.e8d7590a.png";